import { render } from "./KatIcon.vue?vue&type=template&id=c2ac4f30&scoped=true"
import script from "./KatIcon.vue?vue&type=script&lang=js"
export * from "./KatIcon.vue?vue&type=script&lang=js"

import "./KatIcon.vue?vue&type=style&index=0&id=c2ac4f30&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2ac4f30"]])

export default __exports__